import { createAction } from 'redux-actions';
import * as types from './constants';

export const getFunctionalLocationInfoRequest =
    createAction(types.GET_FUNCTIONAL_LOCATION_INFO_REQUEST);
export const getFunctionalLocationInfoSuccess =
    createAction(types.GET_FUNCTIONAL_LOCATION_INFO_SUCCESS);
export const getFunctionalLocationInfoFailure =
    createAction(types.GET_FUNCTIONAL_LOCATION_INFO_FAILURE);

export const saveFunctionalLocationInfoRequest =
    createAction(types.SAVE_FUNCTIONAL_LOCATION_INFO_REQUEST);
export const saveFunctionalLocationInfoSuccess =
    createAction(types.SAVE_FUNCTIONAL_LOCATION_INFO_SUCCESS);
export const saveFunctionalLocationInfoFailure =
    createAction(types.SAVE_FUNCTIONAL_LOCATION_INFO_FAILURE);

export const resetSaveSuccess = createAction(types.RESET_SAVE_SUCCESS);
export const resetInfo = createAction(types.RESET_INFO);
